var map = {
	"./100.jpg": 999,
	"./100.png": 9332,
	"./b.png": 9076,
	"./buld.jpg": 8543,
	"./byjus.png": 1925,
	"./codeInLogo.png": 7935,
	"./codeuino.jpg": 8394,
	"./coursera_logo.png": 1877,
	"./cra.png": 3634,
	"./dal.png": 6288,
	"./data_camp.png": 3606,
	"./deeplearning_ai_logo.png": 2862,
	"./dsa.png": 798,
	"./embibe.png": 2516,
	"./googleAssistant.jpg": 700,
	"./google_logo.png": 5927,
	"./ino.png": 6380,
	"./intel_logo.jpg": 3026,
	"./jeevat.jpg": 1144,
	"./jeevat.png": 8292,
	"./js.png": 6118,
	"./kce.jpg": 8141,
	"./logo.svg": 805,
	"./nptel.jpg": 4929,
	"./nptel.png": 5235,
	"./prpleslate.png": 5097,
	"./quicko.jpg": 917,
	"./react.png": 6091,
	"./recode.jpg": 9768,
	"./sal.png": 5693,
	"./stanford_logo.png": 7137,
	"./vjt.png": 7115,
	"./wrighter.jpg": 7039,
	"./zoho.png": 440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;